import { SignIn } from "@clerk/react";
import { useLocation } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import { clerkAppearance } from "@/auth/clerk-appearance";

type NavState = {
  callbackUrl?: string;
  initialValues?: { emailAddress?: string };
};

const SignInPage = () => {
  const location = useLocation();
  const state = (location.state as NavState | null) || {};
  const redirectUrl = state.callbackUrl || "/auth-callback";

  return (
    <AuthLayout mode="sign-in">
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        fallbackRedirectUrl={redirectUrl}
        forceRedirectUrl={redirectUrl}
        initialValues={state.initialValues}
        appearance={clerkAppearance}
      />
    </AuthLayout>
  );
};

export default SignInPage;
